/**
 * 日期格式化
 * @param timeSpan
 * @param format
 * @returns {*}
 */

export function dateFormat(timeSpan, format) {
  if (!timeSpan) return

  const date = new Date(timeSpan)
  const o = {
    'M+': date.getMonth() + 1, // month
    'd+': date.getDate(), // day
    'h+': date.getHours(), // hour
    'm+': date.getMinutes(), // minute
    's+': date.getSeconds(), // second
    'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
    'S': date.getMilliseconds() // millisecond
  }
  if (/(y+)/.test(format)) { format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }

  for (const k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }

  return format
}

/**
 * js时间转化为几天前,几小时前，几分钟前
 * @param dateTimeStamp
 * @returns {string}
 */
export function getDateDiff(dateTimeStamp) {
  const minute = 1000 * 60
  const hour = minute * 60
  const day = hour * 24
  // const halfamonth = day * 15
  const month = day * 30
  // let now = new Date().getTime();
  const now = Date.now()
  const diffValue = now - dateTimeStamp
  if (diffValue < 0) {
    return
  }
  const monthC = diffValue / month
  const weekC = diffValue / (7 * day)
  const dayC = diffValue / day
  const hourC = diffValue / hour
  const minC = diffValue / minute
  let result = ''
  if (monthC >= 1) {
    result = '' + parseInt(monthC) + '月前'
  } else if (weekC >= 1) {
    result = '' + parseInt(weekC) + '周前'
  } else if (dayC >= 1) {
    result = '' + parseInt(dayC) + '天前'
  } else if (hourC >= 1) {
    result = '' + parseInt(hourC) + '小时前'
  } else if (minC >= 1) {
    result = '' + parseInt(minC) + '分钟前'
  } else {
    result = '刚刚'
  }

  return result
}

/**
 * 保留小数
 * @param number
 * @param digits
 * @returns {string}
 */
export function numberToFixed(number, digits) {
  return (number || 0).toFixed(digits)
}

/**
 * 替换 \n | \r\n 为<br/>
 * @param {string} string
 */
export function parseText2Html(string) {
  return string.replace(/\n | \r\n/g, '<br/>')
}

